import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { mediaUrl } from "@/lib/media";
import { Button } from "@/components/ui/button";
import { GraduationCap, Loader2 } from "lucide-react";

export default function Workshops() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/content/workshops").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24">
      <div className="max-w-2xl mb-16">
        <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Workshops</span>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-3 mb-4">Learn the craft of frequency wellness.</h1>
        <p className="text-muted-foreground leading-relaxed">Immersive cohort programs led by VoiceMatrix AI practitioners, with limited seats per cohort.</p>
      </div>

      {items === null ? (
        <div className="py-20 grid place-items-center"><Loader2 className="animate-spin text-primary" strokeWidth={1.5} /></div>
      ) : (
        <div className="space-y-4">
          {items.map((w, i) => (
            <div key={w.id} className="rounded-2xl border border-border bg-card p-6 sm:p-8 flex flex-col md:flex-row md:items-center gap-6" data-testid={`workshop-${i}`}>
              {w.image_url ? (
                <img src={mediaUrl(w.image_url)} alt={w.title} className="h-20 w-20 rounded-2xl object-cover shrink-0" />
              ) : (
                <span className="grid place-items-center h-14 w-14 rounded-2xl bg-primary/15 text-primary shrink-0"><GraduationCap strokeWidth={1.5} /></span>
              )}
              <div className="flex-1">
                <h3 className="font-serif text-2xl mb-1">{w.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed max-w-2xl">{w.description}</p>
              </div>
              <div className="flex items-center gap-5 md:flex-col md:items-end">
                <span className="font-serif text-2xl text-primary">₹{Number(w.price || 0).toLocaleString("en-IN")}</span>
                <Link to="/book"><Button className="rounded-full bg-primary text-primary-foreground hover:bg-primary/85 font-semibold whitespace-nowrap" data-testid={`workshop-register-${i}`}>Register</Button></Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
